import React from 'react'

import { H4, HeaderOffsetProvider } from 'components/ArticleComponents'
import { Renderer } from 'components/CustomMDX'

export const ConditionalMDXSection = ({ title, content, topLevel = 1 }) => {
	if (!content?.body) return null

	return (
		<>
			{title && <H4>{title}</H4>}
			<HeaderOffsetProvider topLevel={topLevel}>
				<Renderer>{content.body}</Renderer>
			</HeaderOffsetProvider>
		</>
	)
}
